export interface ConfigInterface {
  env: string
  url: string
  socketURL: string
  stripePublishableKey: string
  amplitudeApiKey?: string
  discordOauthUrl?: string
  discordRedirectUrl?: string
}

interface Envs {
  [key: string]: ConfigInterface
}

const envs: Envs = {
  local: {
    env: 'local',
    url: 'http://localhost:4000/',
    socketURL: 'ws://localhost:4000/',
    discordOauthUrl:
      'https://discord.com/api/oauth2/authorize?client_id=824614621423468544&redirect_uri=http%3A%2F%2Flocalhost%3A3000&response_type=code&scope=identify',
    discordRedirectUrl: 'http://localhost:3000',
    stripePublishableKey:
      'pk_test_51K6KZYD3u3eeH8G4DfBPvrQGflnE4T3bYtNU3A6kGuhGw6iYe67z5OzGgHdfuQla1bm0f2bad6iIxySp6TRyAA1E008PAGojDE',
  },
  dev: {
    env: 'dev',
    url: 'https://api.fitgmr.dev.cleverbuild.biz/',
    socketURL: 'wss://api.fitgmr.dev.cleverbuild.biz/',
    discordOauthUrl:
      'https://discord.com/api/oauth2/authorize?client_id=824614621423468544&redirect_uri=https%3A%2F%2Ffitgmr.dev.cleverbuild.biz%2Fauth%2Flogin%2F&response_type=code&scope=identify%20email',
    discordRedirectUrl: 'https://fitgmr.dev.cleverbuild.biz/auth/login/',
    stripePublishableKey:
      'pk_test_51K6KZYD3u3eeH8G4DfBPvrQGflnE4T3bYtNU3A6kGuhGw6iYe67z5OzGgHdfuQla1bm0f2bad6iIxySp6TRyAA1E008PAGojDE',
  },
  qa: {
    env: 'qa',
    url: 'https://api.fitgmr.qa.cleverbuild.biz/',
    socketURL: 'wss://api.fitgmr.qa.cleverbuild.biz',
    discordOauthUrl:
      'https://discord.com/api/oauth2/authorize?client_id=834460307127533629&redirect_uri=https%3A%2F%2Ffitgmr.qa.cleverbuild.biz%2Fauth%2Flogin%2F&response_type=code&scope=identify%20email',
    discordRedirectUrl: 'https://fitgmr.qa.cleverbuild.biz/auth/login/',
    stripePublishableKey:
      'pk_test_51K6Ka5DVKecRA7eewT1S8jtJceDeQQzih1vZHCYGJp6HZSACfua16mAvsdPAZvc4El6XBGUFFbEuDqiENxIDNtGf00vw33Eq7s',
  },
  staging: {
    env: 'staging',
    url: 'https://api.fitgmr.staging.cleverbuild.biz/',
    socketURL: 'wss://api.fitgmr.staging.cleverbuild.biz/',
    amplitudeApiKey: '05ea27cf07ab4ecb6d80e92ddfa1479c',
    discordOauthUrl:
      'https://discord.com/api/oauth2/authorize?client_id=834460307127533629&redirect_uri=https%3A%2F%2Ffitgmr.staging.cleverbuild.biz%2Fauth%2Flogin%2F&response_type=code&scope=identify%20email',
    discordRedirectUrl: 'https://fitgmr.staging.cleverbuild.biz/auth/login/',
    stripePublishableKey:
      'pk_test_51K1xBTLy0aYixfPQoOiWDmZrDzqfKzlamocQIURNYurdXCJLX0U5dZzcaOLRGbcG7wXltem72vV6NlsxXGleCjiE00AJlciQJC',
  },
  production: {
    env: 'production',
    url: 'https://api.app.fitgmr.gg/',
    socketURL: 'wss://api.app.fitgmr.gg/',
    amplitudeApiKey: 'bcefad6eec7f020305328a7cdb24e7c8',
    discordOauthUrl:
      'https://discord.com/api/oauth2/authorize?client_id=888195319773425705&redirect_uri=https%3A%2F%2Fadmin.app.fitgmr.gg%2Fauth%2Flogin%2F&response_type=code&scope=identify%20email',
    discordRedirectUrl: 'https://admin.app.fitgmr.gg/auth/login/',
    stripePublishableKey:
      'pk_live_51K1xBTLy0aYixfPQ0h8OYUJSV1JaF96qbMqnfdIPrmEUEfYpvsxn0ZVu5LjXiaWEDiJwuEOVShwElC3qfQFEiEOM00tBHgsdwK',
  },
}

export const config = envs[process.env.REACT_APP_ENV || 'dev']
